module.exports = "/_next/static/images/icon_ready-bb459bd675989fa9b2ce1b7c2ddaee8d.svg";